import {
  baseEventFragmentPayload,
  baseExperienceFragmentPayload,
  ClickstreamPayload,
  EventType,
} from 'modules/analytics';

type Track = (data: ClickstreamPayload) => void;

export const searchWidgetPresentedEvent = (
  track: Track,
  program: { name: string; id: string },
  referrerIdPrefix: string
): void => {
  const pageName =
    referrerIdPrefix && referrerIdPrefix === 'managed' ? 'managed_search_widget' : 'affhub_search_widget';
  const openEvent = {
    event: {
      ...baseEventFragmentPayload,
      event_type: EventType.IMPRESSION,
      event_name: 'affhub_search_widget.presented',
      action_reason: program?.id,
    },
    experience: {
      ...baseExperienceFragmentPayload,
      page_name: pageName || 'affiliate_hub_search_widget',
      page_name_detailed: 'Affiliate Hub Products',
    },
    // Commenting out until affhub_context is approved
    // affhub_context: {
    //   app_location: referrerIdPrefix,
    //   program: {
    //     program_name: program?.name,
    //     program_id: program?.id,
    //   },
    //   product: {
    //     product_name: product,
    //   },
    // },
  };
  track(openEvent);
};
export const searchWidgetSearchSelectedEvent = (
  track: Track,
  program: { name: string; id: string },
  referrerIdPrefix: string
): void => {
  const pageName =
    referrerIdPrefix && referrerIdPrefix === 'managed' ? 'managed_search_widget' : 'affhub_search_widget';
  const openEvent = {
    event: {
      ...baseEventFragmentPayload,
      event_type: EventType.INTERACTION,
      event_name: 'affhub_search_widget_search.selected',
      action_reason: program?.id,
    },
    experience: {
      ...baseExperienceFragmentPayload,
      page_name: pageName || 'affiliate_hub_search_widget',
      page_name_detailed: 'Affiliate Hub Products',
    },
    // Commenting out until affhub_context is approved
    // affhub_context: {
    //   app_location: referrerIdPrefix,
    //   program: {
    //     program_name: program?.name,
    //     program_id: program?.id,
    //   },
    //   product: {
    //     product_name: product,
    //   },
    //   link: {
    //     link_type: link.type,
    //     link_index: link.index,
    //     link_target_url: link.url,
    //   },
    // },
  };
  track(openEvent);
};
